module.exports = __webpack_public_path__ + "static/media/rain-night.dd8866e2.jpeg";